module.exports = __webpack_public_path__ + "assets/img/21.38b0fdbb.png";